import React from "react";
import { EditCityModal } from "../../Modal/EditCityModal";

export function CityEditModal({
  isLoadingEditCity,
  handleEditHide,
  isEditModal,
  data,
  stateList,
  formikEditCity,
  onClickOfEditCityCancelButton,
}) {
  return (
    <>
      <EditCityModal
        isLoadingEditCity={isLoadingEditCity}
        handleEditHide={handleEditHide}
        isEditModal={isEditModal}
        data={data}
        stateList={stateList}
        formikEditCity={formikEditCity}
        onClickOfCancelButton={onClickOfEditCityCancelButton}
      />
    </>
  );
}
